import { useQueries } from "@tanstack/react-query";

import { partQuery } from "#modules/parts/infra/part.query";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";

export const useLiveQuoteRequestLineParts = (
  quoteRequestLines: (QuoteRequestLineDto | null | undefined)[],
): (QuoteRequestLineDto | null | undefined)[] => {
  const loadedLines = quoteRequestLines.filter((line): line is QuoteRequestLineDto => !!line);

  const partQueries = useQueries({
    queries: loadedLines.map((line) => ({
      ...partQuery(line.partId),
      initialData: line.part,
      enabled: !!line.partId,
    })),
  });

  const livePartByLineId = new Map(
    loadedLines.map((line, index) => [line.id, partQueries[index]?.data]),
  );

  return quoteRequestLines.map((line) => {
    if (!line) {
      return line;
    }
    const livePart = livePartByLineId.get(line.id);
    return livePart ? { ...line, part: livePart } : line;
  });
};
